// @flow
import MainSearchBox from './MainSearchBox';

export default MainSearchBox;



// WEBPACK FOOTER //
// ./src/components/main/MainSearchBox/index.js